var _path, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkingNearCyclewayWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5769 2.40698C14.2258 2.40698 16.4027 3.30255 17.8822 4.16031C19.8851 5.32062 20.6536 7.50357 20.6536 9.45205V12.0389C22.0259 12.9013 27.515 16.8376 28.7872 17.8417C29.0889 18.0958 29.2795 18.4577 29.3183 18.8502C29.357 19.2428 29.2409 19.635 28.9947 19.9431C28.7484 20.2513 28.3916 20.4511 28.0001 20.5C27.6087 20.5489 27.2137 20.4429 26.8992 20.2047C26.2223 19.6717 21.364 16.16 20.6536 15.6726V25.9853C20.6536 27.7563 19.9501 29.4547 18.6978 30.707C17.4456 31.9593 15.7471 32.6628 13.9761 32.6628H9.17758C7.40661 32.6628 5.70817 31.9593 4.4559 30.707C3.20364 29.4547 2.50012 27.7563 2.50012 25.9853V15.6726V9.45205C2.50012 7.50206 3.26862 5.32062 5.27155 4.16031C6.75106 3.30255 8.92948 2.40698 11.5769 2.40698ZM17.445 16.8329L17.628 16.6484V25.9853L17.6159 26.2743C17.5471 27.14 17.1719 27.9529 16.5578 28.567C15.9437 29.1811 15.1308 29.5562 14.2651 29.6251L13.9761 29.6372H9.17758L8.88863 29.6251C8.02289 29.5562 7.21003 29.1811 6.59592 28.567C5.98181 27.9529 5.60667 27.14 5.53781 26.2743L5.5257 25.9838V16.6499L5.70875 16.8314L5.93416 17.0735C6.57919 17.8204 6.96317 18.7573 7.0279 19.742L7.03849 20.0416V25.0988L7.04757 25.3363C7.10405 26.0565 7.41634 26.7327 7.92797 27.2427C8.4396 27.7526 9.11681 28.0627 9.83716 28.1169L10.0641 28.1244H13.0897L13.3272 28.1153C14.0473 28.0589 14.7235 27.7466 15.2335 27.2349C15.7435 26.7233 16.0535 26.0461 16.1077 25.3258L16.1152 25.0988V20.0416L16.1273 19.7118C16.1988 18.7275 16.5891 17.7933 17.2392 17.0508L17.445 16.8329ZM8.35765 12.3112C9.63444 11.7742 10.7388 11.4837 11.5769 11.4837C12.4165 11.4837 13.5208 11.7742 14.7946 12.3112C15.4596 12.5931 16.1109 12.9066 16.7461 13.2507L15.3044 14.6924L15.029 14.9828C13.7801 16.3718 13.0893 18.1737 13.0897 20.0416V25.0988H10.0641V20.0416L10.0535 19.6407C9.95486 17.7757 9.16976 16.0131 7.84935 14.6924L6.40766 13.2507L7.05816 12.9133C7.49384 12.6945 7.927 12.4938 8.35765 12.3112ZM6.78888 6.77895C7.96129 6.09819 9.61477 5.43256 11.5769 5.43256C13.539 5.43256 15.1924 6.09819 16.3648 6.77743C17.1394 7.22673 17.628 8.19189 17.628 9.45053V10.2977C17.0819 10.0193 16.5252 9.75612 15.97 9.52163C14.551 8.92408 13.008 8.45814 11.5769 8.45814C10.1458 8.45814 8.60272 8.92408 7.18372 9.52012C6.62853 9.7546 6.07182 10.0178 5.5257 10.2977V9.45053C5.5257 8.19038 6.01433 7.22522 6.78888 6.77895Z",
    fill: "#fff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25.885,
    y1: 1.61112,
    x2: 25.885,
    y2: 6.22794,
    stroke: "#fff",
    strokeWidth: 2.77009,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.885,
    y1: 12.6917,
    x2: 25.885,
    y2: 17.3085,
    stroke: "#fff",
    strokeWidth: 2.77009,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 25.885,
    y1: 23.7719,
    x2: 25.885,
    y2: 28.3887,
    stroke: "#fff",
    strokeWidth: 2.77009,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingNearCyclewayWhite);
export default __webpack_public_path__ + "static/media/parking-near-cycleway-white.10b107b9517aaaa100aa51aed132a725.svg";
export { ForwardRef as ReactComponent };